@if (chatService.hostFeed) {
  <div id="host-chat-feed" class="chat-feed-wrapper">
    @for (msg of chatService.hostFeed; track msg) {
      <div #messageBox class="chat-msg-box">
        <div class="chat-msg-header">
          <div class="chat-msg-sender">
            <strong [title]="msg.sender.firstName + ' ' + (msg.sender.lastName || '')">
              @if (msg.sentByMe) {
                (<b>Host</b>) You
              } @else {
                (<b>Host</b>) {{ formatUsersName(msg.sender.firstName, msg.sender.lastName) }}
              }
            </strong>
            to
            @if (msg.privacy === 'hosts') {
              <strong>Hosts</strong>
            }
          </div>
        </div>
        <div class="chat-msg-content" [innerHtml]="msg.message"></div>
        <div class="chat-msg-footer" [title]="msg.sentDate.toString()">
          {{ msg.sentDate | timeDiffAsync | async }}
        </div>
        @if (shouldShowError(msg)) {
          <div class="chat-msg-failed">
            Message failed to send. Check network connection and <strong>try again</strong>.
          </div>
        }
      </div>
    }
  </div>
}
